import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Reports|Recently Reimported Exams|Details|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Exam,
	portal: 'SP',
};

export type SPReportsRecentlyReimportedExamsDetailsLocNames =
	| 'SPReportsRecentlyReimportedExamsDetailsTitleTab'
	| 'SPReportsRecentlyReimportedExamsDetailsTitlePage'
	| 'SPReportsRecentlyReimportedExamsDetailsTitleSection'
	| 'SPReportsRecentlyReimportedExamsDetailsLabelRegistrationNumber'
	| 'SPReportsRecentlyReimportedExamsDetailsLabelTestCenter'
	| 'SPReportsRecentlyReimportedExamsDetailsLabelExamCode'
	| 'SPReportsRecentlyReimportedExamsDetailsLabelCandidateId'
	| 'SPReportsRecentlyReimportedExamsDetailsButtonDownloadAllData';

export const spReportsRecentlyReimportedExamsDetailsLocs: LocDefs<SPReportsRecentlyReimportedExamsDetailsLocNames> =
	{
		SPReportsRecentlyReimportedExamsDetailsTitleTab: {
			defaultValue: 'Recently Re-Imported Exams Details',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			legacyName: 'Exam/Reporting.RecentlyReImportedExamsDetails.Title.TabTitle',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsDetailsTitlePage: {
			defaultValue: 'Recently Re-Imported Exams Report',
			description: 'Page Title',
			displayPath: `${pathStart}Page Title`,
			displayType: 'Title',
			legacyName: 'Exam/Reporting.RecentlyReImportedExams.Title.PageTitle',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsDetailsTitleSection: {
			defaultValue: 'Recently Re-Imported Exams',
			description: 'Section Title',
			displayPath: `${pathStart}Section Title`,
			displayType: 'Title',
			legacyName: 'Exam/Reporting.RecentlyReImportedExams.Title.SectionTitle',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsDetailsLabelRegistrationNumber: {
			defaultValue: 'Registration Number',
			description: 'Column heading for: Registration Number.',
			displayPath: `${pathStart}Registration Number`,
			displayType: 'Title',
			legacyName:
				'Exam/Reporting.RecentlyReImportedExamsDetails.ColumnHeading.RegistrationNumber',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsDetailsLabelTestCenter: {
			defaultValue: 'Test Center',
			description: 'Column heading for: Test Center.',
			displayPath: `${pathStart}Test Center`,
			displayType: 'Title',
			legacyName: 'Exam/Reporting.RecentlyReImportedExamsDetails.ColumnHeading.TestCenter',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsDetailsLabelExamCode: {
			defaultValue: 'Exam Code',
			description: 'Column heading for: Exam Code.',
			displayPath: `${pathStart}Exam Code`,
			displayType: 'Title',
			legacyName: 'Exam/Reporting.RecentlyReImportedExamsDetails.ColumnHeading.ExamCode',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsDetailsLabelCandidateId: {
			defaultValue: 'Candidate ID',
			description: 'Column heading for: Candidate ID.',
			displayPath: `${pathStart}Candidate ID`,
			displayType: 'Title',
			legacyName: 'Exam/Reporting.RecentlyReImportedExamsDetails.ColumnHeading.CandidateId',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsDetailsButtonDownloadAllData: {
			defaultValue: 'Download All Data',
			description: 'Button to download all data.',
			displayPath: `${pathStart}Button Download All Data`,
			displayType: 'Button',
			...sharedProperties,
		},
	};

export const LOC_KEYS = MapLocKeys<SPReportsRecentlyReimportedExamsDetailsLocNames>(spReportsRecentlyReimportedExamsDetailsLocs);

export type SPReportsRecentlyReimportedExamsDetailsLocType =
	LocMap<SPReportsRecentlyReimportedExamsDetailsLocNames>;
